import script from "./EPeriodontalGraphic.vue?vue&type=script&lang=ts&setup=true"
export * from "./EPeriodontalGraphic.vue?vue&type=script&lang=ts&setup=true"

import "./EPeriodontalGraphic.vue?vue&type=style&index=0&id=ec3489fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec3489fc"]])

export default __exports__